var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import qs from 'qs';
import getNewCart from './getNewCart';
import getFullFibrePlans from './getFullFibrePlans';
import AppState from '../AppState';
/**
 * Retrieves the service qualification manual for a given address.
 *
 * @param {Address} addressValues - The address values of the location.
 * @returns {Promise<object>} - A Promise that resolves to the service qualification.
 */
const getServiceQualificationManual = (addressValues) => __awaiter(void 0, void 0, void 0, function* () {
    const drupalJsObjects = AppState.get('drupalJsObjects');
    const { settings } = drupalJsObjects;
    const { vocusApiRoot, vocusApiCart, vocusApiRootAddressManual, onePlatformApiRoot, onePlatformApiClientId, onePlatformApiClientSecret } = settings;
    const onePlatformSqDataBuild = {
        'provideaAlternative': true,
        'validAddress': {
            'streetNr': addressValues.StreetNumber,
            'streetName': addressValues.StreetName,
            'streetType': addressValues.StreetType,
            'postcode': addressValues.Postcode,
            'suburb': addressValues.Suburb,
            'state': addressValues.StateName
        }
    };
    const onePlatformSqData = JSON.stringify(onePlatformSqDataBuild);
    // Obtain the service address object via One Platform.
    const onePlatformServiceQualificationEndpoint = onePlatformApiRoot + vocusApiRootAddressManual;
    const onePlatformServiceQualificationObject = yield fetch(`${onePlatformServiceQualificationEndpoint}`, {
        method: 'post',
        headers: {
            'client_id': onePlatformApiClientId,
            'client_secret': onePlatformApiClientSecret,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: onePlatformSqData,
    })
        .then(response => {
        if (!response.ok) {
            return false;
        }
        else {
            return response.json();
        }
    })
        .catch(error => console.log(error));
    if (onePlatformServiceQualificationObject && onePlatformServiceQualificationObject.compositeAddress.length > 0) {
        return {
            onePlatformServiceQualification: onePlatformServiceQualificationObject,
            serviceQualification: false,
            address: {},
            salesId: '',
            token: '',
        };
    }
    // Obtain a new salesID and token.
    const { sales_idField, tokenField } = yield getNewCart(vocusApiRoot, vocusApiCart);
    const dataBuild = {
        salesId: parseInt(sales_idField),
        organisationType: 1,
        address: addressValues,
        token: tokenField,
    };
    const planData = qs.stringify(dataBuild, { arrayFormat: 'indices' });
    return yield getFullFibrePlans(planData, addressValues, sales_idField, tokenField);
});
export default getServiceQualificationManual;
